export const socialData = {
  contactInfo: {
    phone: {
      label: 'Phone',
      value: '+91 99926 27742',
      url: 'tel:+919992627742',
      icon: 'FaPhone'
    },
    email: {
      label: 'Email',
      value: 'info@astrointeriors.in',
      url: 'mailto:info@astrointeriors.in',
      icon: 'FaEnvelope'
    },
    location: {
      label: 'Location',
      value: 'Sector 62 Noida Uttar Pradesh, India - 201301',
      icon: 'FaMapMarkerAlt'
    }
  },
  socialLinks: [
    {
      name: 'Facebook',
      url: 'https://facebook.com/astrointeriors.in',
      icon: 'FaFacebookF',
      color: '#4267B2'
    },
    {
      name: 'Twitter',
      url: 'https://twitter.com/astrointeriors.in',
      icon: 'FaTwitter',
      color: '#1DA1F2'
    },
    {
      name: 'Instagram',
      url: 'https://instagram.com/astrointeriors.in',
      icon: 'FaInstagram',
      color: '#E1306C'
    },
    {
      name: 'LinkedIn',
      url: 'https://www.linkedin.com/company/astrointeriors.in/',
      icon: 'FaLinkedinIn',
      color: '#0077B5'
    }
  ]
};
